import { t } from 'ttag'
import { useMemo } from 'react'

import { SLB } from '@h2/components/colors'
import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'
import { Option, OptionGroup } from '@h2/components/containers/optionGroup'
import { ProgramIcon } from '@h2/components/icons/program'
import { EducatorIcon } from '@h2/components/icons/educator'
import { CogIcon } from '@h2/components/icons/cog'
import { LibrarianIcon } from '@h2/components/icons/librarian'
import { Card } from '@h2/common/components/card'

import { props } from './props'
import { ContentWrap, OptionBody } from './components'

import { Navigator } from '../highlights/navigator'
import { Back } from '../back'
import { Controls } from '../controls'

const K12EducatorType = ({ inDialog, properties, validate, renderPanel }) => {
  const k12EducatorType = useMemo(() => properties.k12EducatorType, [
    properties.k12EducatorType
  ])

  return (
    <Card inDialog={inDialog}>
      <Card.Highlight color={SLB}>
        <Navigator type="educator" />
      </Card.Highlight>
      <Card.Content>
        <ContentWrap>
          <Heading level="2" align="center" mb="12px">
            {t`Which describes your role best...`}
          </Heading>
          <Text align="center">{t`If none of these apply, just select the closest option.`}</Text>
          <OptionGroup
            gap="15px"
            value={k12EducatorType}
            onClick={value => validate({ k12EducatorType: value })}>
            <Option value="teacher">
              <OptionBody>
                <EducatorIcon size="large" />
                <span className="flex">
                  <span>{t`Teacher`}</span>
                  <span>{t`I teach and inspire students.`}</span>
                </span>
              </OptionBody>
            </Option>
            <Option value="counselor">
              <OptionBody>
                <ProgramIcon size="large" />
                <span className="flex">
                  <span>{t`Counselor`}</span>
                  <span>{t`I counsel students and help people get to where they want to go.`}</span>
                </span>
              </OptionBody>
            </Option>
            <Option value="administrator">
              <OptionBody>
                <CogIcon size="large" />
                <span className="flex">
                  <span>{t`Administrator`}</span>
                  <span>{t`I help keep my school or organization running and enable others to excel.`}</span>
                </span>
              </OptionBody>
            </Option>
            <Option value="librarian">
              <OptionBody>
                <LibrarianIcon size="large" />
                <span className="flex">
                  <span>{t`Librarian`}</span>
                  <span>{t`I coach, advise, direct and provide a valuable resource to patrons looking for help.`}</span>
                </span>
              </OptionBody>
            </Option>
          </OptionGroup>
          <Controls>
            <Back onClick={() => renderPanel('educatorType')} />
          </Controls>
        </ContentWrap>
      </Card.Content>
      <Card.Detour>
        <Back onClick={() => renderPanel('educatorType')} />
      </Card.Detour>
    </Card>
  )
}

K12EducatorType.propTypes = { ...props }

export { K12EducatorType }
